module.exports = __webpack_public_path__ + "img/mz.1044789.svg";